export const resolveContactImageSrc = (photoFile?: string): string => {
  if (!photoFile) {
    return '';
  }

  if (/^https?:\/\//i.test(photoFile)) {
    return photoFile;
  }

  return `/contactImages/${photoFile}`;
};
